var map = {
	"./example.svg": 196,
	"./eye-open.svg": 197,
	"./eye.svg": 198,
	"./form.svg": 199,
	"./link.svg": 200,
	"./nested.svg": 201,
	"./password.svg": 202,
	"./table.svg": 203,
	"./tree.svg": 204,
	"./user.svg": 205
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = 195
// module chunks = 11